import { cn } from '@/lib/utils'

interface AssessmentResult {
  id: string
  date: string
  isOverall: boolean
  attemptNumber?: number
}

interface ResultsSidebarProps {
  results: AssessmentResult[]
  selectedResult: string
  onSelectResult: (id: string) => void
}

export default function ResultsSidebar({
  results,
  selectedResult,
  onSelectResult,
}: ResultsSidebarProps) {
  return (
    <aside className='flex h-full w-full lg:w-[242px] flex-col'>
      {/* Results List */}
      <div className='flex-1 bg-[#F5F6F8] rounded-[19px] px-4 py-7'>
        <nav className='space-y-6'>
          {results.map((result) => {
            const isActive = selectedResult === result.id

            return (
              <button
                key={result.id}
                onClick={() => onSelectResult(result.id)}
                className='relative flex w-full items-center justify-between text-left'
              >
                {/* Active indicator - orange bar on left */}
                {isActive && (
                  <div className='absolute -left-4 top-1/2 h-[31px] w-[3px] -translate-y-1/2 bg-[#FF6600]' />
                )}

                <div className='flex-1 min-w-0 pr-3'>
                  {result.isOverall ? (
                    <span className='text-[14px] font-bold leading-[21px] text-[#151515]'>
                      {result.date}:
                    </span>
                  ) : (
                    <div className='flex flex-col'>
                      <span className='text-[14px] font-bold leading-[21px] text-[#151515]'>
                        {result.attemptNumber ? `Attempt #${result.attemptNumber}` : 'Assessment Result'}:
                      </span>
                      <span className='text-[14px] font-normal leading-[21px] text-[#151515]'>
                        {result.date}
                      </span>
                    </div>
                  )}
                </div>

                {/* Status indicator - radio button style */}
                <div
                  className={cn(
                    'h-[24px] w-[24px] rounded-full border-2 flex items-center justify-center shrink-0',
                    isActive ? 'border-[#FF6600]' : 'border-[#4e4d4d]'
                  )}
                >
                  {isActive && (
                    <div className='h-[8px] w-[8px] rounded-full bg-[#FF6600]' />
                  )}
                </div>
              </button>
            )
          })}
        </nav>
      </div>
    </aside>
  )
}
